import $fetch from 'lib/fetch';
import { z } from 'zod';
import { API_BASE_URL, parseResponseData } from '../../utils';
import {
  GetRecentEsimOrdersParams,
  GetRecentPSimOrdersParams,
  GetReportParams,
} from './dashboard.requests.types';
import dashboardResponseSchemas from './dashboard.responses.schemas';

const BASE_SERVICE_URL = `${API_BASE_URL}/dashboard` as const;

// We are overloading this because the api returns data in different structure
// based on the type of report requested
// `unknown` for unused types as of now
export function getReport(params: { type: 'activated' }): Promise<unknown>;
export function getReport(params: { type: 'deactivated' }): Promise<unknown>;
export function getReport(params: { type: 'paused' }): Promise<unknown>;
export function getReport(params: {
  type: 'orders';
}): Promise<
  Readonly<z.infer<typeof dashboardResponseSchemas.getReport.orders>>
>;
export async function getReport(params: GetReportParams) {
  const response = await $fetch(`${BASE_SERVICE_URL}/getreports`, {
    method: 'POST',
    body: JSON.stringify(params),
  });

  switch (params.type) {
    case 'orders':
      return parseResponseData(
        response,
        dashboardResponseSchemas.getReport.orders
      );
    default:
      return parseResponseData(response, z.unknown());
  }
}

export async function getRecentEsimOrders(params: GetRecentEsimOrdersParams) {
  const response = await $fetch(`${BASE_SERVICE_URL}/recent-eSIM-orders`, {
    method: 'POST',
    body: JSON.stringify(params),
  });

  const data = parseResponseData(
    response,
    dashboardResponseSchemas.getRecentEsimOrders
  );

  return data;
}

export async function getRecentPSimOrders(params: GetRecentPSimOrdersParams) {
  const response = await $fetch(`${BASE_SERVICE_URL}/recent-orders`, {
    method: 'POST',
    body: JSON.stringify(params),
  });

  const data = parseResponseData(
    response,
    dashboardResponseSchemas.getRecentPSimOrders
  );

  return data;
}
